import { MOSIDA_API_ORIGIN } from "../config/apiUrls";

const IMAGE_READ_PATH = "/api/image-processing/read";

function isDataOrBlobUrl(value: string): boolean {
  return value.startsWith("data:") || value.startsWith("blob:");
}

function isAlreadyImageReadUrl(value: string): boolean {
  return value.includes(`${IMAGE_READ_PATH}?url=`);
}

/**
 * Build the API URL for image reads using:
 * GET /api/image-processing/read?url=<encoded-source-url>
 */
export function buildImageReadApiUrl(sourceUrl: string): string {
  const trimmed = (sourceUrl || "").trim();
  if (!trimmed) return trimmed;
  if (isDataOrBlobUrl(trimmed) || isAlreadyImageReadUrl(trimmed)) return trimmed;
  const base = MOSIDA_API_ORIGIN.replace(/\/+$/, "");
  return `${base}${IMAGE_READ_PATH}?url=${encodeURIComponent(trimmed)}`;
}

/**
 * Fetch image bytes via the image-processing/read API for remote URLs.
 * For data/blob URLs, this falls back to direct fetch.
 */
export async function fetchImage(sourceUrl: string, init?: RequestInit): Promise<Response> {
  const resolved = buildImageReadApiUrl(sourceUrl);
  const headers = new Headers(init?.headers || {});
  if (!headers.has("accept")) {
    headers.set("accept", "image/*");
  }
  return fetch(resolved, {
    ...init,
    method: init?.method || "GET",
    headers,
  });
}
